<template>
  <div>
    <common-dialog ref="dialog" 
    width="900px" 
     :show-save-button="$permission.canEdit()"
     unit="保税商品信息" 
     edit-title id-key="RecordId" 
     :data="data"
      :get-data-func="api.info" 
      :form-rules="rules" 
      :save-func="api.save"
       @create-opened="onCreateOpened"
      @edit-opened="onEditOpened" 
      :before-save="onBeforeSave" 
      close-on-saved 
      form-label-width="150px"
      @close-saved="$emit('close-saved')"
       @closed="onClosed">
      <template slot="form">
        
         <el-row>
           <el-col :span="isMB ? 24 : 12">
            <el-form-item label="商品编号" prop="FilingsOrderid">
              <el-input v-model="data.FilingsOrderid" placeholder="请输入商品编号" clearable></el-input>
            </el-form-item>
          </el-col>

           <el-col :span="isMB ? 24 : 12">
            <el-form-item label="商品货号" prop="GoodsArticleno">
              <el-input v-model="data.GoodsArticleno" placeholder="请输入商品货号" clearable></el-input>
            </el-form-item>
          </el-col>

          
         
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="商品名称" prop="FilingsName">
              <el-input v-model="data.FilingsName" placeholder="请输入商品名称" clearable></el-input>
            </el-form-item>
          </el-col>
          
       <!--    <el-col :span="isMB ? 24 : 12">
            <el-form-item label="备案序号" prop="FilingsOrderid">
              <el-input v-model="data.FilingsOrderid" placeholder="请输入备案序号" clearable></el-input>
            </el-form-item>
          </el-col>  -->
         
         
        </el-row>
        
       

        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="物料号" prop="FilingsMaterialno">
              <el-input v-model="data.FilingsMaterialno" placeholder="请输入物料号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
           
            <el-form-item label="商品品牌" prop="BrandId">
              <el-select v-model="data.BrandId" placeholder="请选择商品品牌" clearable>
                  <el-option v-for="(i, k) in Brands" :key="k" :label="i.BrandName" :value="i.RecordId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
         
        </el-row>
        
           
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="类目" prop="FilingsCategory">
              <el-input v-model="data.FilingsCategory" placeholder="请输入类目" clearable></el-input>
            </el-form-item>
          </el-col>

           <el-col :span="isMB ? 24 : 12">
           
            <el-form-item label="征免方式" prop="TaxationId">
              <el-select v-model="data.TaxationId" placeholder="请选择征免方式" clearable>
                  <el-option v-for="(i, k) in Taxations" :key="k" :label="i.TaxationCode+i.TaxationName" :value="i.RecordId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
       </el-row>
        
           
        
        <el-row>
                   
          
          <el-col :span="isMB?24:12">
              <el-form-item label="计量单位" prop="MainUnitid">
                <el-select v-model="data.MainUnitid" placeholder="请选择计量单位" clearable>
                  <el-option v-for="(i, k) in Units" :key="k" :label="i.UnitName" :value="i.RecordId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="isMB ? 24 : 12">
            <el-form-item label="计量单位数量" prop="MainUnitcount">
              <el-input v-model="data.MainUnitcount" placeholder="请输入计量单位数量" type="number" clearable></el-input>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="isMB?24:12">
              <el-form-item label="法定单位" prop="LegalUnitid">
                <el-select v-model="data.LegalUnitid" placeholder="请选择法定单位" clearable>
                  <el-option v-for="(i, k) in Units" :key="k" :label="i.UnitName" :value="i.RecordId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
           <el-col :span="isMB ? 24 : 12">
            <el-form-item label="法定单位数量" prop="LegalUnitcount">
              <el-input v-model="data.LegalUnitcount" placeholder="请输入法定单位数量" type="number" clearable></el-input>
            </el-form-item>
          </el-col>


        </el-row>


        <el-row>
          
            <el-col :span="isMB?24:12">
              <el-form-item label="第二计量单位" prop="SecondUnitid">
                <el-select v-model="data.SecondUnitid" placeholder="请选择第二计量单位" clearable>
                  <el-option v-for="(i, k) in Units" :key="k" :label="i.UnitName" :value="i.RecordId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

              <el-col :span="isMB ? 24 : 12">
            <el-form-item label="第二计量单位数量" prop="SecondUnitcount">
              <el-input v-model="data.SecondUnitcount" placeholder="请输入第二计量单位数量" type="number" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
         <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="原产国" prop="CountryId">
              <el-select v-model="data.CountryId" placeholder="请选择原产国" clearable>
                  <el-option v-for="(i, k) in Countrys" :key="k" :label="i.CountryCode+i.CountryName" :value="i.RecordId"></el-option>
              </el-select>
            </el-form-item>
          </el-col> 
          
          <el-col :span="isMB ? 24 : 12">
             <el-form-item label="币制" prop="CurrencyId">
              <el-select v-model="data.CurrencyId" placeholder="请选择币制" clearable>
                  <el-option v-for="(i, k) in Currencys" :key="k" :label="i.CurrencyCode+i.CurrencyName" :value="i.RecordId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
         
                  
        </el-row>

         <el-row>

          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="税率" prop="TaxRate">
              <el-input v-model="data.TaxRate" placeholder="请输入税率" type="number" clearable><template slot="append"><div style="width:20px;text-align:center">%</div></template></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="消费税" prop="ConsumptionTax">
              <el-input v-model="data.ConsumptionTax" placeholder="请输入消费税" type="number" clearable></el-input>
            </el-form-item>
          </el-col>
         
         
        </el-row>

         <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="净重" prop="NetWeight">
              <el-input v-model="data.NetWeight" placeholder="请输入净重" type="number" clearable><template slot="append" ><div style="width:20px;text-align:center">KG</div></template></el-input>
            </el-form-item>
          </el-col>

           <el-col :span="isMB ? 24 : 12">
            <el-form-item label="毛重" prop="GrossWeight">
              <el-input v-model="data.GrossWeight" placeholder="请输入毛重" type="number" clearable><template slot="append" ><div style="width:20px;text-align:center">KG</div></template></el-input>
            </el-form-item>
          </el-col>
         
        </el-row>
      

         <el-row>

          <el-col :span="24">
            <el-form-item label="成分规格" prop="ComponentSpecifi">
              <el-input v-model="data.ComponentSpecifi" type="textarea" rows="3" placeholder="请输入成分规格" clearable></el-input>
            </el-form-item>
          </el-col>
        
        </el-row>

                
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="序号" prop="OrderId">
              <el-input-number v-model="data.OrderId" :min="0" />
            </el-form-item>
          </el-col>
                 
      <!--    <el-col :span="isMB ? 24 : 12" v-if="data.RecordId">
            <el-form-item label="备案状态">
              {{ data.FilingsState == 0 ? "未备案" : "已备案" }}
            </el-form-item>
          </el-col>-->
        </el-row>
      </template>
      <template v-if="false">
        <el-table :data="cList" :border="true" :show-header="false">
          <el-table-column prop="name" align="center">
            <template slot-scope="{ row }">
              <table v-if="row.type == 1" class="table">
                <tr>
                  <td
                    v-for="sitem in row.data"
                    :key="sitem.id"
                    :style="rowStyle(sitem)"
                  >
                    <table v-if="sitem.type == 1" class="table">
                      <tr v-for="kitem in sitem.data" :key="kitem.id">
                        <td
                          v-for="ditem in kitem.data"
                          :key="ditem.id"
                          :style="rowStyle(ditem)"
                        >
                          {{ ditem.name }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="text-align: center"
                          :colspan="sitem.data.length"
                        >
                          {{ sitem.name }}
                        </td>
                      </tr>
                    </table>
                    <div v-else>{{ sitem.name }}</div>
                  </td>
                </tr>
              </table>
              <div v-else>{{ row.name }}</div>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template v-if="false">
        <el-table :data="pList" :border="true">
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column
            v-for="item in wList"
            :key="item.id"
            :label="item.name"
          >
            <template slot-scope="{ row }">
              {{
                row.data.filter((x) => x.type == item.id).length > 0
                  ? row.data.filter((x) => x.type == item.id)[0].level
                  : ""
              }}
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template #footer v-if="!$permission.canEdit()">
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import singlePicUpload from "@/components/common/photo/singleUpload";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    singlePicUpload,
  },
 
  computed: {
    
  },
  data() {
    return {
      data: {
        RecordId: 0,
        OrderId: 0,
        GoodsArticleno: "",
        GoodsCode: "",
       
        FilingsName: "",
        FilingsOrderid: "",
        FilingsMaterialno: "",
        
        BrandId: null,
        FilingsCategory: "",
        ComponentSpecifi: "",
        MainUnitid:null,
       
        MainUnitcount:"",
        LegalUnitid: null,
        LegalUnitcount: "",
        SecondUnitid: null,
        SecondUnitcount: "",
        OriginCountry: "",
        TaxRate: null,
        ConsumptionTax: "",
        CurrencySystem: "",
        NetWeight: "",
        GrossWeight: "",
        FilingsState:1,
        TaxationId: null,
        CountryId: null,
        CurrencyId: null,
      },
      saveState: 0,
      isEdit: false,
      api: require("@/api/goods/infobonded").default,
      brand_api: require("@/api/goods/brandplatform").default,
      unit_api: require("@/api/goods/unitplatform").default,
      taxation_api:require("@/api/sy/taxation").default,
      country_api:require("@/api/sy/country").default,
      Currency_api:require("@/api/sy/currency").default,
      isMB: this.$store.state.isMB,
      rules: {
        FilingsOrderid: [{ required: true, message: "商品编号不能为空" }],
        GoodsArticleno: [{ required: true, message: "商品货号不能为空" }],
        FilingsName: [{ required: true, message: "商品名称不能为空" }],
       
      
     //   FilingsMaterialno: [{ required: true, message: "备案物料号不能为空" }],
        BrandId: [{ required: true, message: "商品品牌不能为空" }],
     //   FilingsCategory: [{ required: true, message: "类目不能为空" }],
        MainUnitid: [{ required: true, message: "计量单位不能为空" }],
        OrderId: [{ required: true, message: "序号不能为空" }],
     //   TaxationId: [{ required: true, message: "征免方式不能为空" }],
      //  CountryId: [{ required: true, message: "原产国不能为空" }],
      },
      Brands: [],
      Units: [],
      Taxations: [],
      Countrys: [],
      Currencys: [],
      uploadUrl: "/api/Common/UploadPicture",

      cList: [
        {
          id: 1,
          name: "",
          type: "1",
          data: [
            {
              id: 1,
              name: "通道",
              type: "0",
            },
            {
              id: 2,
              name: "库位01",
              type: "1",
              color: "red",
              data: [
                {
                  id: 1,
                  data: [
                    {
                      id: 1,
                      name: "柜位001",
                      type: "0",
                      color: "green",
                    },
                    {
                      id: 2,
                      name: "柜位002",
                      type: "0",
                      color: "green",
                    },
                  ],
                },
                {
                  id: 2,
                  data: [
                    {
                      id: 3,
                      name: "柜位003",
                      type: "0",
                  color: "blue",
                    },
                    {
                      id: 4,
                      name: "柜位004",
                      type: "0",
                  color: "blue",
                    },
                  ],
                },
              ],
            },
            {
              id: 3,
              name: "库位02",
              type: "1",
              color: "yellow",
              data: [
                {
                  id: 1,
                  data: [
                    {
                      id: 1,
                      name: "柜位001",
                      type: "0",
                  color: "Purple",
                    },
                    {
                      id: 2,
                      name: "柜位002",
                      type: "0",
                  color: "Purple",
                    },
                  ],
                },
                {
                  id: 2,
                  data: [
                    {
                      id: 3,
                      name: "柜位003",
                      type: "0",
                  color: "orange",
                    },
                    {
                      id: 4,
                      name: "柜位004",
                      type: "0",
                  color: "orange",
                    },
                  ],
                },
              ],
            },
            {
              id: 4,
              name: "库位03",
              type: "1",
              color: "brown",
              data: [
                {
                  id: 1,
                  data: [
                    {
                      id: 1,
                      name: "柜位001",
                      type: "0",
                  color: "orange",
                    },
                    {
                      id: 2,
                      name: "柜位002",
                      type: "0",
                  color: "orange",
                    },
                  ],
                },
                {
                  id: 2,
                  data: [
                    {
                      id: 3,
                      name: "柜位003",
                      type: "0",
                  color: "pink",
                    },
                    {
                      id: 4,
                      name: "柜位004",
                      type: "0",
                  color: "pink",
                    },
                  ],
                },
              ],
            },
          ],
        },
        { id: 2, name: "通道", type: "0" },
        { id: 3, name: "", type: "1" },
        { id: 4, name: "", type: "1" },
      ],
      wList: [
        { id: 1, name: "厨师" },
        { id: 2, name: "汽修" },
        { id: 3, name: "技工" },
        { id: 4, name: "公务员" },
      ],
      pList: [
        {
          id: 1,
          name: "张三",
          data: [
            { type: 1, level: "一级" },
            { type: 2, level: "一级" },
            { type: 3, level: "一级" },
          ],
        },
        {
          id: 2,
          name: "李四",
          data: [
            { type: 2, level: "一级" },
            { type: 3, level: "一级" },
          ],
        },
        {
          id: 3,
          name: "王二",
          data: [
            { type: 1, level: "一级" },
            { type: 3, level: "一级" },
          ],
        },
        {
          id: 4,
          name: "苟六",
          data: [
            { type: 4, level: "一级" },
            { type: 2, level: "二级" },
          ],
        },
      ],
    };
  },
   mounted() {
    this.unit_api.list({ State: 1 }).then(res => {
      if (res.Code == 0) {
        this.Units = res.Data;
      }
    }),
     this.brand_api.list({ State: 1 }).then(res => {
      if (res.Code == 0) {
        this.Brands = res.Data;
      }
    }),
    this.taxation_api.list({ State: 1 }).then(res => {
      if (res.Code == 0) {
        this.Taxations = res.Data;
      }
    }),
    this.country_api.list({ State: 1 }).then(res => {
      if (res.Code == 0) {
        this.Countrys = res.Data;
      }
    }),
    this.Currency_api.list({ State: 1 }).then(res => {
      if (res.Code == 0) {
        this.Currencys = res.Data;
      }
    })
  },
  methods: {
    onCreateOpened(row) {
    
      this.api.getMaxOrderId().then((res) => {
        if (res.Code == 0) this.data.OrderId = res.Data;
      });
    },
    onEditOpened(row) {
      this.isEdit = true;
   
    },
    toSave(t) {
      this.saveState = t;
      this.save();
    },
    onBeforeSave() {},
    onClosed() {},

    rowStyle(item) {
      return {
        backgroundColor: item.color,
      };
    },
  },
};
</script>
<style>
.table {
  border-collapse: collapse; /* 合并边框 */
  width: 100%; /* 设置表格宽度为100% */
}

.table tr,
.table td {
  padding: 8px; /* 设置单元格内边距 */
  text-align: center; /* 文本居中 */
  border: 1px solid #ddd; /* 设置边框样式 */
}
</style>